import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { EpDataViewModelService, IEpPanelbarModel, EpButtonStyle, EpButtonType, EpDialogInstance } from '@epicor/kinetic';
import {
  Opportunity, Quote, Order, TemplateOrder, CallOffOrderHeader,
  Invoice, CreditNote, ObjectAttachmentFolderListType, BisTrackSettings,
  DocumentAttachmentFolderListType, Kind, CustomerProductPurchaseExtended,
  QuoteOrderStatus, StockTransfer, EmailTemplate, WorksOrder, PurchaseOrder, FieldAgentClient
} from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaDocumentDetailService } from '../../services/epbt-fa-document-detail.service';
import { DocumentTypes, DateFormats, DocumentListType, ErrorStatus, SearchPageNames } from 'ep-bt-controls';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EpbtFaQuickOrderEmailComponent } from '../epbt-fa-quick-order-email/epbt-fa-quick-order-email.component';
import { EpbtFaQuickOrderSummaryComponent } from '../epbt-fa-quick-order-summary/epbt-fa-quick-order-summary.component';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaQuickOrderSummaryService } from '../../services/epbt-fa-quick-order-summary.service';
import { EpbtFaSmartviewsService } from '../../services/epbt-fa-smartviews.service';
import { QuickOrderModel } from '../../models/quick-order.model';
import { EpbtFaEpaReturnParametersModel } from '../../models/epbt-fa-epa-return-parameters-model';
import { EpbtFaReturnParametersModel } from '../../models/epbt-fa-return-parameters-model';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-open-document',
  templateUrl: './epbt-fa-open-document.component.html',
  styleUrls: ['./epbt-fa-open-document.component.scss']
})
export class EpbtFaOpenDocumentComponent implements OnInit {

  instance: EpDialogInstance;
  _enableOpenDocument: boolean;
  @Input('enableOpenDocument') set enableOpenDocument (value: boolean) {
    this._enableOpenDocument = value;
    this.enableOpenDocumentChange.emit(this._enableOpenDocument);
  }
  @Input() backwardUrlTitle: string;

  get enableOpenDocument(): boolean {
    return this._enableOpenDocument;
  }
  @Output() enableOpenDocumentChange = new EventEmitter<any>();
  @ViewChild(EpbtFaQuickOrderEmailComponent, { static: false }) epbtFaQuickOrderEmailComponent: EpbtFaQuickOrderEmailComponent;
  @ViewChild(EpbtFaQuickOrderSummaryComponent, { static: false }) epbtFaQuickOrderSummaryComponent: EpbtFaQuickOrderSummaryComponent;
  EpButtonStyle = EpButtonStyle;
  EpButtonType = EpButtonType;
  @Input() customerId: number;
  customerCode: string;
  selectedItem: any;
  selectedItemDetails: any;
  label: string;
  pageTitle: string;
  documentType: string;
  currency: string;
  dateFormat: string;
  objectListType: ObjectAttachmentFolderListType;
  documentListType: DocumentAttachmentFolderListType;
  baseFolderName: string;
  type: string;
  sourceId: number;
  sourceItemCode: string;
  signatureType = 0;
  backTitle: string;
  webTrackUser: any;
  bistrackSettings: BisTrackSettings;
  acceptFlag: boolean;
  makePaymentFlag = false;
  codPaymentFlag = false;
  emailFlag = false;
  // emailButtonFlag: boolean = false;
  index = 0;

  orderTotalAmount: number = null;
  orderTotalAmountDisplay: number;

  errorMessage = '';
  paymentLabel = 'Make Payment'; // Make COD Payment

  successFlag = false;
  successDateFromat: string = DateFormats.LongDateWith12Hours;

  url: SafeResourceUrl;
  epaUrl: SafeResourceUrl;
  isQuickOrder: boolean;
  constructor(public faDocumentDetailService: EpbtFaDocumentDetailService, private faService: EpbtFieldAgentService,
    private route: ActivatedRoute, private location: Location, private client: FieldAgentClient,
    private router: Router, public quickOrderService: EpbtFaQuickOrderService,
    public quickOrderSummaryService: EpbtFaQuickOrderSummaryService,
    private sanitizer: DomSanitizer, private SmartviewsService: EpbtFaSmartviewsService) {
    window.addEventListener('storage', this.paymentComplete.bind(this));
  }

  ngOnInit() {

    // var paymentUrl = window.location.origin + "/BisTrack/home/quickorder/payment";
    // var paymentUrl = window.location.origin + "/BisTrack/payment";
    const paymentUrl = window.location.origin + '/BisTrack/assets/payment.html';
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(paymentUrl);

    const epaPaymentUrl = window.location.origin + '/BisTrack/assets/paymentEpicor.html';
    this.epaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(epaPaymentUrl);

    this.acceptFlag = false;
    this.makePaymentFlag = false;
    this.codPaymentFlag = false;
    this.emailFlag = false;
    this.quickOrderSummaryService.emailButtonFlag = false;
    const item = EpDataViewModelService.current.item('selectedItem').data[0];

    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = bistrackSettings.baseCurrency.symbol;
      this.dateFormat = bistrackSettings.shortDateFormat ? bistrackSettings.shortDateFormat : DateFormats.ShortDate;
      this.faService.getWebTrackUser((webTrackUser: any) => {

        if (item instanceof Quote || item instanceof Order || item instanceof Invoice || item instanceof CallOffOrderHeader || item instanceof TemplateOrder) {
          this.faService.checkDisplayPermissions('UserCanSeeCosts', (totalCostFlag: any) => {
            this.faDocumentDetailService.totalCostFlag = totalCostFlag;
            if (!totalCostFlag) {
              this.faService.checkDisplayPermissions('ShowOrderMarginWithoutCosts', (totalMarginFlag: any) => {
                this.faDocumentDetailService.totalMarginFlag = totalMarginFlag;
              });
            }
          });
        }

        this.webTrackUser = webTrackUser;
        if (item instanceof Quote || item.type == DocumentAttachmentFolderListType.Quote) {
          this.acceptFlag = (this.webTrackUser.allowPlaceOrders &&
            (item.orderStatus == QuoteOrderStatus.Open || item.orderStatus == QuoteOrderStatus.QuoteAccepted) && this.bistrackSettings.allowMultipleQuoteAccept) ? true : false;
        } else if (item instanceof Order) {
          this.client.getOrderPayments(item.orderId).subscribe(result => {
            item.orderPayments = result;
            if (item.cashSale && item.invoiced == false && item.paymentOutstandingInCurrency >= this.bistrackSettings.minimumAllowedPaymentAmount) {
              this.makePaymentFlag = true;
              this.codPaymentFlag = false;
              this.emailFlag = true;
              this.quickOrderSummaryService.emailButtonFlag = true;
              this.paymentLabel = 'Make Payment'; // Make COD Payment
              this.quickOrderSummaryService.geti4goTrueTokenParameters((result: any) => { });
            }

            if (this.bistrackSettings.allowCashOnDeliveries && item.cashSale && item.invoiced == false && item.cashOnDeliveryAmountInCurrency - item.calculatedCODTotalInCurrencyReceived > 0) {
              this.codPaymentFlag = true;
              this.makePaymentFlag = false;
              this.emailFlag = true;
              this.quickOrderSummaryService.emailButtonFlag = true;
              this.paymentLabel = 'Make COD Payment';
              this.quickOrderSummaryService.geti4goTrueTokenParameters((result: any) => { });
            }

            this.quickOrderService.quickOrder = new QuickOrderModel();
            this.quickOrderService.quickOrder.OrderID = item.orderId;
            this.quickOrderService.quickOrder.OrderNumber = item.orderNumber;

            this.client.getCustomer(item.customerID).subscribe(customer => {
              this.quickOrderService.quickOrder.customer = customer;
            });

            this.client.getBranch(item.branchId).subscribe(branch => {
              this.quickOrderService.quickOrder.branch = branch;
            });

            this.client.getCustomerContact(item.contactID).subscribe(contact => {
              this.quickOrderService.quickOrder.contact = contact;
            });
            this.quickOrderService.quickOrder.TransactionType = 1;
            this.quickOrderService.quickOrder.customerRef = item.customerRef;
            this.quickOrderSummaryService.selectedOrder = item;
          });

        }
      });
    });
    this.getData(item);
    this.backTitle = `Back to ${this.backwardUrlTitle}`;
  }

  getData(item: any) {
    if (item instanceof Opportunity) {

    } else if (item instanceof Quote || item.type == DocumentAttachmentFolderListType.Quote) {
      this.label = 'Quote';
      this.pageTitle = item.quoteNumber.toString();

      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.Quote;
      this.baseFolderName = 'Quotes';
      this.type = Kind.Document;
      this.sourceId = item.orderId;
      this.sourceItemCode = item.quoteNumber.toString();
      this.signatureType = DocumentListType.Quote;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.Quotes, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Quote';
        this.documentType = DocumentTypes.Quotes;
      });
    } else if (item instanceof Order || item.type == 'Order') {
      this.label = 'Order';
      this.pageTitle = item.orderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.SalesOrder;
      this.baseFolderName = 'Sales Orders';
      this.type = Kind.Document;
      this.sourceId = item.orderId;
      this.sourceItemCode = item.orderNumber.toString();
      this.signatureType = DocumentListType.SalesOrder;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.Orders, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Order';
        this.documentType = DocumentTypes.Orders;
      });
    } else if (item instanceof TemplateOrder || item.type == DocumentAttachmentFolderListType.TemplateOrder) {
      this.label = 'Template Order';
      this.pageTitle = item.orderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.TemplateOrder;
      this.baseFolderName = 'Template Orders';
      this.type = Kind.Document;
      this.sourceId = item.orderId;
      this.sourceItemCode = item.orderNumber.toString();
      this.signatureType = DocumentListType.TemplateOrder;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.TemplateOrders, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Template Order';
        this.documentType = DocumentTypes.TemplateOrders;
      });
    } else if (item instanceof CallOffOrderHeader || item.type == DocumentAttachmentFolderListType.CallOffOrder) {
      this.label = 'Call Off';
      this.pageTitle = item.orderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.CallOffOrder;
      this.baseFolderName = 'Call Off Orders';
      this.type = Kind.Document;
      this.sourceId = item.orderID;
      this.sourceItemCode = item.orderNumber.toString();
      this.signatureType = DocumentListType.CallOffOrder;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.CallOffOrders, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Call Off';
        this.documentType = DocumentTypes.CallOffOrders;
      });
    } else if (item instanceof Invoice || item.type == DocumentAttachmentFolderListType.Invoice) {
      this.label = 'Invoice';
      this.pageTitle = item.invoiceNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.Invoice;
      this.baseFolderName = 'Invoices';
      this.type = Kind.Document;
      this.sourceId = item.invoiceId;
      this.sourceItemCode = item.invoiceNumber.toString();
      this.signatureType = DocumentListType.Invoice;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.Invoices, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Invoice';
        this.documentType = DocumentTypes.Invoices;
      });
    } else if (item instanceof CreditNote || item.type == DocumentAttachmentFolderListType.CreditNote) {
      this.label = 'Credits';
      this.pageTitle = item.creditNoteNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.CreditNote;
      this.baseFolderName = 'Credit Notes';
      this.type = Kind.Document;
      this.sourceId = item.creditNoteId;
      this.sourceItemCode = item.creditNoteNumber.toString();
      this.signatureType = DocumentListType.CreditNote;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.Credits, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Credits';
        this.documentType = DocumentTypes.Credits;
      });
    } else if (item instanceof CustomerProductPurchaseExtended) {
      this.label = 'Order';
      this.pageTitle = item.orderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.SalesOrder;
      this.baseFolderName = 'Sales Orders';
      this.type = Kind.Document;
      this.sourceId = item.orderId;
      this.sourceItemCode = item.orderNumber.toString();
      this.signatureType = DocumentListType.SalesOrder;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.ProductOrders, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Order';
        this.documentType = DocumentTypes.ProductOrders;
      });
    } else if (item instanceof StockTransfer || item.type == DocumentAttachmentFolderListType.StockTransfer) {
      this.label = 'Stock Transfer';
      this.pageTitle = item.orderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.StockTransfer;
      this.baseFolderName = 'Stock Transfer';
      this.type = Kind.Document;
      this.sourceId = item.orderId;
      this.sourceItemCode = item.orderNumber.toString();
      this.signatureType = DocumentListType.StockTransfer;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.Stocktransfers, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Stock Transfer';
        this.documentType = DocumentTypes.Stocktransfers;
      });
    } else if (item instanceof PurchaseOrder || item.type == DocumentAttachmentFolderListType.PurchaseOrder) {
      this.label = 'Purchase Order';
      this.pageTitle = item.purchaseOrderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.PurchaseOrder;
      this.baseFolderName = 'Purchase Order';
      this.type = Kind.Document;
      this.sourceId = item.purchaseOrderID;
      this.sourceItemCode = item.purchaseOrderNumber.toString();
      this.signatureType = DocumentListType.PurchaseOrder;
      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.PurchaseOrder, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = 'Purchase Order';
        this.documentType = DocumentTypes.PurchaseOrder;
      });
    } else if (item instanceof WorksOrder || item.type == DocumentAttachmentFolderListType.WorksOrder) {
      this.label = 'Work Order';
      this.pageTitle = item.worksOrderNumber.toString();
      // Attachemnt parameters
      this.documentListType = DocumentAttachmentFolderListType.WorksOrder;
      this.baseFolderName = 'Work Order';
      this.type = Kind.Document;
      this.sourceId = item.worksOrderId;
      this.sourceItemCode = item.worksOrderNumber.toString();
      this.signatureType = DocumentListType.WorksOrder;

      item.type = 'WorksOrder';
      let volumeConversion: number;
      this.client.getPerConversion(item.m3PerID, item.mbfPerID, 0, false, 0, 0, 0, 0).subscribe(res => {

        if (res) {
          volumeConversion = this.bistrackSettings.defaultSystemToImperial ? res : 1;

          item.totalVolumeIn = item.totalVolumeIn * volumeConversion;
          item.totalVolumeOut = item.totalVolumeOut * volumeConversion;

          this.selectedItem = item;
          this.selectedItem.title = 'Work Order';
          this.documentType = DocumentTypes.WorkOrders;

          // Selected items storing into service
          this.faDocumentDetailService.selectedWorkOrderItem = [];
          this.faDocumentDetailService.selectedWorkOrderItem = this.selectedItem;
        }
      });

    } else if (item && item.source == 'jp') {
      this.label = item.title;
      this.pageTitle = item.orderNumber.toString();
      // Attachemnt parameters
      // this.documentListType = DocumentAttachmentFolderListType.SalesOrder;
      // this.baseFolderName = "Sales Orders";
      this.type = Kind.Document;
      this.sourceId = item.orderId;
      this.sourceItemCode = item.orderNumber.toString();
      // this.signatureType = DocumentListType.SalesOrder;

      this.faDocumentDetailService.getDetailsFromApi(DocumentTypes.Orders, item, (documentDetail: any) => {
        this.selectedItem = documentDetail;
        this.selectedItem.title = item.title;
        this.documentType = DocumentTypes.ProductOrders;
      });
    }
  }

  acceptQuote() {
    this.faDocumentDetailService.acceptQuote(this.selectedItem, (result: any) => {
      this.webTrackUser.customer.customerId = this.customerId;
      try {
        if (result instanceof Order) {
          EpDataViewModelService.current.add('selectedItem', [result]);
          this.router.navigateByUrl('/home/documents/details', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/home/documents/details', this.customerId]));
        } else {
          this.selectedItem = result;
          this.selectedItem.title = 'Quote';
          this.documentType = DocumentTypes.Quotes;
          this.faService.displayToastMessage('Warning!', 'Quote was accepted, but order record was not found in data base. Order ID:' + this.sourceId, ErrorStatus.Warning);
        }
      } catch (ex) {
        console.log('getOrdersRequest Error :-');
        console.log(ex);
      }
    });
  }

  backButtonClick() {
    this.enableOpenDocument = false;
  }

  public onTabSelect(e) {
    if (this.successFlag) {
      this.successOkClick();
    } else {
      switch (e.index) {
        case 4:
            if (this.quickOrderSummaryService.emailTemplate) {
              this.quickOrderSummaryService.getEmailTemplate((emailTemplate: EmailTemplate) => {
                this.quickOrderSummaryService.emailTemplate = emailTemplate;
                this.index = e.index;
                this.epbtFaQuickOrderEmailComponent.ngOnInit();
              });
            } else {
              this.quickOrderSummaryService.getEmailTemplate((emailTemplate: EmailTemplate) => {
                this.quickOrderSummaryService.emailTemplate = emailTemplate;
                this.index = e.index;
              });
            }
            break;
        case 3:
            this.index = e.index;
            const item = EpDataViewModelService.current.item('selectedItem').data[0];
            if (!this.codPaymentFlag) {
              this.orderTotalAmount = Number(item.paymentOutstandingInCurrency);
              this.orderTotalAmountDisplay = Number(item.paymentOutstandingInCurrency);
            } else {
              this.orderTotalAmount = Number(item.cashOnDeliveryAmountInCurrency - item.cashOnDeliveryReceivedInCurrency);
              this.orderTotalAmountDisplay = Number(item.cashOnDeliveryAmountInCurrency - item.cashOnDeliveryReceivedInCurrency);
            }
            this.quickOrderSummaryService.orderTotalTax = item.totalVat;
            this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
          break;
        default:
            break;
      }
    }

  }

  public sendEmail() {
    this.epbtFaQuickOrderEmailComponent.onSendEmail();
  }


  // Payment

  paymentComplete(event: StorageEvent) {
    const param = localStorage.getItem('Order');
    const type = localStorage.getItem('PaymentType');
    if (!this.quickOrderService.creCardEntryView) {
      if (type && type == 'Order') {
        if (!this.quickOrderSummaryService.cardVerificationFlag && param != null && param != 'undefined' && param != 'Error' && param != 'Return') {
          this.quickOrderSummaryService.cardVerificationFlag = true;
          // localStorage.removeItem("Order");
          this.quickOrderSummaryService.waitFlag = false;
          if (param != 'undefined' && param != 'Error') {
            const payment = JSON.parse(param);

            const item1 = payment['i4go_response'];
            if (item1) {
              this.quickOrderService.quickOrder.i4GoReturnParameters = new EpbtFaReturnParametersModel(payment);
              if (this.quickOrderService.quickOrder.i4GoReturnParameters.success) {
                this.quickOrderSummaryService.paymentComplete((result: boolean) => {
                  if (result) {
                    const item = EpDataViewModelService.current.item('selectedItem').data[0];
                    this.faDocumentDetailService.recalculatePaymentOutstanding(item.orderId, false, (result: any) => {
                      this.faDocumentDetailService.getOrder(item.orderId, (result: any) => {
                        this.paymentLabel = '';
                        this.emailFlag = false;
                        this.successFlag = true;
                        EpDataViewModelService.current.add('selectedItem', [result]);
                      });
                    });
                  }
                });
              } else {
                this.quickOrderSummaryService.setViewsVisible(false, false, false, false, true, false, false);
                this.quickOrderSummaryService.cardVerificationFlag = false;
                this.quickOrderService.errorMessage = this.quickOrderService.quickOrder.i4GoReturnParameters.responseText;
                this.quickOrderService.quickOrder.i4GoReturnParameters = null;
              }
            }

          } else if (param == 'Error') {
            this.quickOrderSummaryService.setViewsVisible(false, false, false, false, true, false, false);
            this.quickOrderSummaryService.cardVerificationFlag = false;
            this.quickOrderService.quickOrder.i4GoReturnParameters = null;
          }
        } else if (param == 'Return') {
          this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
          this.quickOrderService.wizardView = true;
          this.quickOrderSummaryService.cardVerificationFlag = false;
          this.quickOrderService.quickOrder.i4GoReturnParameters = null;
        }
      }
    } else if (this.quickOrderService.creCardEntryView) {
      if (type && type == 'Order') {
        if (!this.quickOrderSummaryService.cardVerificationFlag && param != null && param != 'undefined' && param != 'Error' && param != 'Return') {
          this.quickOrderSummaryService.cardVerificationFlag = true;
          if (param != 'undefined' && param != 'Error') {
            const payment = JSON.parse(param);
            // localStorage.removeItem("QuickOrder");
            // this.quickOrderSummaryService.waitFlag = false;
            const item1 = payment['success'];
            if (item1) {
              this.quickOrderService.quickOrder.epaReturnParameters = new EpbtFaEpaReturnParametersModel(payment);
              if (this.quickOrderService.quickOrder.epaReturnParameters.success) {
                this.quickOrderSummaryService.paymentCompleteForEpa((result: boolean) => {
                  console.log(result);
                });
              } else {
                this.quickOrderSummaryService.setViewsVisible(false, false, false, false, true, false, false);
                this.quickOrderSummaryService.cardVerificationFlag = false;
                this.quickOrderService.errorMessage = 'Error'; // this.quickOrderService.quickOrder.i4GoReturnParameters.responseText;
                this.quickOrderService.quickOrder.epaReturnParameters = null;
              }
            }
          } else if (param == 'Error') {
            this.quickOrderSummaryService.setViewsVisible(false, false, false, false, true, false, false);
            this.quickOrderSummaryService.cardVerificationFlag = false;
            this.quickOrderService.quickOrder.epaReturnParameters = null;
          }
        } else if (param == 'Return') {
          this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
          this.quickOrderService.wizardView = true;
          this.quickOrderSummaryService.cardVerificationFlag = false;
          this.quickOrderService.quickOrder.epaReturnParameters = null;
        }
      }
    }
  }

  buttonClick(buttonName: string) {
    if (this.orderTotalAmount == null || this.orderTotalAmount == 0) {
      if (this.orderTotalAmount == null) {
        this.errorMessage = '*';
      } else if (this.orderTotalAmount == 0) {
        this.errorMessage = 'Invalid payment amount';
      }
    } else {

      if (this.orderTotalAmount < this.bistrackSettings.minimumAllowedPaymentAmount) {
        this.errorMessage = 'Invalid payment amount';
      } else if (this.orderTotalAmount > Math.max(this.bistrackSettings.minimumAllowedPaymentAmount, this.orderTotalAmountDisplay)) {
        this.errorMessage = 'Invalid payment amount';
        Math.max(this.bistrackSettings.minimumAllowedPaymentAmount, this.orderTotalAmountDisplay);
      } else {
        this.quickOrderSummaryService.isQuickOrder = false;
        this.quickOrderSummaryService.orderTotalAmount = this.orderTotalAmount;
        this.epbtFaQuickOrderSummaryComponent.buttonClick(buttonName);
      }
    }
  }

  successOkClick() {
    const item = EpDataViewModelService.current.item('selectedItem').data[0];
    this.router.navigateByUrl('/home/documents/details', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/home/documents/details', this.customerId]));
  }

  return() {
    this.quickOrderSummaryService.setViewsVisible(true, false, false, false, false, false, false);
  }

  getStyles() {

    const styles = {
      'width': '100%',
      'height': this.getHeight().toString() + 'px',
      'border': 0
    };
    return styles;
  }

  getHeight(): number {
    const height = $(window).outerHeight() - 350;
    const width = parseInt($('body').width());
    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;
  }


}
